import { api } from "@/services";
import { formatDates } from "@/utils/formatDates";
import { useDate } from "@/utilsV2";

type Inputs = {
  cpf: string;
  email: string;
  name: string;
  date: string;
  phone: string;
  celphone: string;
  password: string;
  zipcode: string;
  number: string;
  complement: string;
  street: string;
  district: string;
  city: string;
  state: string;
};

export async function useRegisterPFClient({
  cpf,
  email,
  name,
  date,
  phone,
  celphone,
  password,
  zipcode,
  number,
  street,
  district,
  city,
  state,
  complement
}: Inputs) {
  const Origin = process.env.NEXT_PUBLIC_PRIMARY_STORE || "LINGLONG";
  const RequestJson = JSON.stringify({
    type: "ClientePF",
    password: password,
    email: email,
    registrationOrigin: `${Origin} - shared`,
    paymentPermission: {
      boleto: true,
      credito: true,
      debito: true,
      pix: true
    },
    marketing: {
      indication: null,
      promotion: false,
      whatsapp: false,
      personalizedAds: false
    },
    addresses: [
      {
        TipoEndereco: "PRINCIPAL",
        rua: street,
        uf: state,
        cidade: city,
        bairro: district,
        latitude: 0,
        longitude: 0,
        cep: zipcode.toString().replace(/[^0-9]/g, ""),
        complemento: complement,
        numero: number
      },
      {
        TipoEndereco: "ENTREGA",
        rua: street,
        uf: state,
        cidade: city,
        bairro: district,
        latitude: 0,
        longitude: 0,
        cep: zipcode.toString().replace(/[^0-9]/g, ""),
        complemento: complement,
        numero: number
      }
    ],
    telephones: [
      {
        type: "Telefone1",
        number: phone
      },
      {
        type: "Telefone2",
        number: phone
      },
      {
        type: "Celular",
        number: celphone
      }
    ],
    clientPFData: {
      cpf: cpf,
      name: name,
      birthDate: useDate(date, "ISO").replace("Z", "+00:00")
    }
  });

  let Response = null;
  let Error = null;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const resp = await api.post(`/Client/RegisterBeta`, RequestJson, {
        signal: Controller.signal,
        headers: {
          "Content-Type": "application/json"
        }
      });
      console.log(resp.data);
      if (resp.data.status) {
        Response = resp.data;
      } else {
        Error = ["Não foi possível realizar o cadastro.", resp.data.msgs[0]];
      }
    } catch (e) {
      Error = ["Não foi possível realizar o cadastro.", e.message];
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, Error];
}
